// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAihDM5SMu8t17Zf5EreLUARLGu6Fh-9Kw",
  authDomain: "spkl-admin.firebaseapp.com",
  projectId: "spkl-admin",
  storageBucket: "spkl-admin.appspot.com",
  messagingSenderId: "49850825639",
  appId: "1:49850825639:web:195153a7b12cc2ddc49482",
  measurementId: "G-MFV4XN9GT5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
export { app, auth };
